import { Component, EventEmitter, Input, Output } from '@angular/core';
interface DropdownItem {
  label: string;
  value: number | string;
  preSelected?: boolean;
  children?: Array<DropdownItem>;
}
@Component({
  selector: 'papi-custom-dropdown',
  templateUrl: './papi-custom-dropdown.component.html',
})
export class PapiCustomDropdownComponent {
  @Input() disabled: boolean;
  @Input() classList: string;
  @Input() dropdownMenu: Array<DropdownItem> = [];
  @Input() placeholder: string;
  @Input() label: string;
  @Input() icon: string;
  @Input() isMultiSelect: boolean;
  @Input() hasSearch: boolean;
  @Output() onItemSelect = new EventEmitter<any>();
  @Output() onSearchChange = new EventEmitter<string>();

  selectedItems: DropdownItem[] = [];
  dropdownOpen: boolean = false;
  searchInput: string;

  ngOnInit(): void {
    this.selectedItems = this.dropdownMenu?.filter(
      (item: DropdownItem) => item.preSelected
    ) || []
  }

  itemSelected(item: DropdownItem): boolean {
    return !!this.selectedItems?.find(({ value }) => item.value === value);
  }

  toggleSelectedItem(item: DropdownItem) {
    let itemIndex = this.selectedItems.findIndex(
      ({ value }) => item.value === value
    );
    if (this.isMultiSelect) {
      if (itemIndex !== -1) {
        this.selectedItems.splice(itemIndex, 1);
      } else {
        this.selectedItems.push(item);
      }

      this.onItemSelect.emit(this.selectedItems);
    } else {
      if (itemIndex !== -1) {
        this.selectedItems = [];
      } else {
        this.selectedItems = [item];
      }

      this.onItemSelect.emit(item);
      this.dropdownOpen = false;
    }
  }

  get passedClassList() {
    return { [this.classList]: true, 'pointer-events-none': this.disabled };
  }

  reset() {
    this.selectedItems = [];
    this.searchInput = '';
  }
}
